export default __webpack_public_path__ + "static/2025 StM Annual School Report-00f6451f4b7d4bee06dcca0ae571c2f7.pdf";